import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clearApiError } from 'store/apiError/actions';
import logoSvg from 'assets/images/logo.svg';

const GlobalApiError = () => {
  const error = useSelector(state => state.apiError);
  const dispatch = useDispatch();
  const { push } = useHistory();
  const { t } = useTranslation();

  if (!error) return null;

  const handleGoBack = () => {
    dispatch(clearApiError());
    // Goes to the previous page in the browser history
    if (window.history.length > 1) {
      window.history.back();
    } else {
      push('/'); // Fallback if there is no history
    }
  };

  const handleGoHome = () => {
    dispatch(clearApiError());
    push('/');
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(255, 255, 255, 0.99)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 24,
      }}
    >
      <img
        src={logoSvg}
        alt="Logo"
        style={{
          width: 368,
          height: 'auto',
          maxWidth: '100%',
          marginBottom: 48,
        }}
      />

      <i
        className="bx bx-error-circle mb-3"
        style={{ fontSize: 64, color: '#f04438' }}
      />

      <h3 className="mb-2" style={{ color: '#2a3042' }}>
        {t('common.pageUnavailableErrTitle', 'Page Unavailable')}
      </h3>

      <p
        className="mb-4"
        style={{ maxWidth: 540, color: '#74788d', fontSize: '1.05rem' }}
      >
        {t(
          'common.pageUnavailableErrDescription',
          'This page does not exist or you do not have permission to access it.',
        )}
      </p>

      <div className="d-flex gap-3 mt-2">
        {/* Go Back Button */}
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={handleGoBack}
          style={{
            padding: '8px 24px',
            fontWeight: 500,
          }}
        >
          {t('common.backToPrevPage')}
        </button>

        {/* Return to Dashboard Button */}
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleGoHome}
          style={{
            backgroundColor: '#556ee6',
            borderColor: '#556ee6',
            padding: '8px 24px',
            fontWeight: 500,
          }}
        >
          {t('common.returnToDashboard')}
        </button>
      </div>
    </div>
  );
};

export default GlobalApiError;
